<template>
  <div class="flex flex-col w-1/3 mr-6">
    <div class="whatsapp-container">
      <div class="whatsapp-message">
        <div class="message-content">
          <div v-if="headerImage" class="mb-4 flex items-center align-center">
            <img
              :src="headerImage"
              alt="Header Image"
              class="w-full max-w-xs shadow"
            />
          </div>
          <div v-if="contentHeader" class="mb-4 flex items-center align-cener">
            <div class="header-text">{{ contentHeader }}</div>
          </div>
          <pre class="info-text whitespace-pre-line">
  {{ contentMessages }}
</pre
          >
          <div v-if="isButtonMessages">
            <div class="button-container">
              <button
                v-for="(btn, index) in buttonMessages"
                :key="index"
                class="payment-button"
              >
                {{ btn.text }}
              </button>
            </div>
          </div>
        </div>
        <div class="message-tail"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    headerImage: {
      type: String,
      default: '',
    },
    contentMessages: {
      type: String,
      default: '',
    },
    contentHeader: {
      type: String,
      default: '',
    },
    buttonMessages: {
      type: Array,
      default: [],
    },
    isButtonMessages: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.whatsapp-container {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica,
    Arial, sans-serif;
  max-width: 100%;
  padding: 8px 12px;
  border-radius: 7.5px;
  background-color: #e5ddd5;
  background-image: url('data:image/png;base64,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');
}

.whatsapp-message {
  position: relative;
  max-width: 90%;
  margin-right: 12px;
  margin-bottom: 15px;
  margin-top: 15px;
}

.message-content {
  background-color: #dcf8c6;
  padding: 8px 10px;
  border-radius: 7.5px;
  box-shadow: 0 1px 0.5px rgba(0, 0, 0, 0.13);
  word-wrap: break-word;
}

.greeting {
  font-weight: 500;
  margin-bottom: 12px;
  margin-top: 0;
}

.info-text {
  font-size: 12px;
  color: black;
  margin-top: 12px;
  margin-bottom: 12px;
}

.header-text {
  font-size: 13px;
  color: black;
  font-weight: bold;
}

.highlight {
  color: #0000ee;
}

.button-container {
  display: flex;
  justify-content: center;
  margin-top: 12px;
  padding-top: 8px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.payment-button {
  font-size:13px;
  color: #0000ee;
  background: transparent;
  border: none;
  font-weight: 500;
  padding: 4px 16px;
  cursor: pointer;
}

.message-tail {
  position: absolute;
  bottom: 3px;
  right: -8px;
  width: 16px;
  height: 10px;
  background-color: #dcf8c6;
  clip-path: polygon(0 0, 100% 100%, 0 100%);
}
</style>
